var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChefshat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2563 18.1221C13.48 16.417 13.063 14.5704 13.0312 12.6971C13.3996 9.54426 14.9131 6.63652 17.2844 4.5262C19.6556 2.41588 22.7194 1.25 25.8937 1.25C29.068 1.25 32.1318 2.41588 34.503 4.5262C36.8743 6.63652 38.3879 9.54426 38.7563 12.6971C38.7056 14.568 38.2895 16.411 37.5312 18.1221",
    stroke: "#6B6B6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3321 32.9971C9.38142 32.4631 6.71263 30.9082 4.79299 28.6047C2.87335 26.3011 1.82521 23.3957 1.83206 20.3971C1.83206 13.3971 6.55709 9.02209 13.5571 9.02209",
    stroke: "#6B6B6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0586 9.02209C45.2336 9.02209 49.9586 13.3971 49.9586 20.3971C49.9654 23.3957 48.9173 26.3011 46.9977 28.6047C45.078 30.9082 42.4092 32.4631 39.4586 32.9971",
    stroke: "#6B6B6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 32.9972V46.2972H39.2821V32.9972",
    stroke: "#6B6B6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 39.6471H39.2821",
    stroke: "#6B6B6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8086 39.6471V32.6471",
    stroke: "#6B6B6B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefshat);
export default __webpack_public_path__ + "static/media/chef's hat.0cdad1bc892fb0d9db900b5c08dc5c33.svg";
export { ForwardRef as ReactComponent };